import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";

const EmployeeAccountsTableDropdown = ({
  data,
  setUpdateTitle,
  setUpdateBody,
  setUpdateData,
  setUpdateBtnText,
  setUpdateBtnColor,
  setToggleModal,
  setDataModal,
  setLastAction
}) => {
  const currentRoute = useLocation().pathname;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  
  const editLink = `${currentRoute}/${data.id}/update/`;

  const activateBtnText = data.is_active ? "Deactivate" : "Activate";
  const activateBtnColor = data.is_active? "danger" : "success";
  const activateAction = data.is_active ? `Account de-activated for Employee Account ${data.username}.` : `Account activated for Employee Account ${data.username}.`;
  const activateUpdateData = data.is_active? {"is_active": false} : {"is_active": true};
  const activateBodyText = data.is_active? `Are you sure you want to De-Activate Employee Account ${data.username}` : `Are you sure you want to Activate Employee Account ${data.username}?`;

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        Action
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem>
            <Link to={editLink}>Edit</Link>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            setUpdateBtnText(activateBtnText);
            setUpdateBtnColor(activateBtnColor);
            setUpdateData(activateUpdateData);
            setUpdateBody(activateBodyText);
            setLastAction(activateAction);
            setDataModal(data);
            setToggleModal(true);
          }}
          style={{ cursor: "pointer" }}
        >
          {activateBtnText}
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default EmployeeAccountsTableDropdown;
